<template>
  <v-container fluid>
    <!-- <v-card class="pt-3">
      <v-card-title
        class="text-h6 back-title"
        @click="$router.push('/immigration-matter')"
        style="cursor: pointer;"
      >&lt;Back</v-card-title>
    </v-card> -->
            <v-row align="center" class="mb-2" no-gutters>
      <v-col>
        <div class="text-h6 font-weight-bold">Edit Immigration Matter</div>
      </v-col>
      <v-col cols="auto">
        <v-btn outlined small @click="$router.push('/immigration-matter')"><v-icon left small>mdi-arrow-left</v-icon>Back</v-btn>
      </v-col>
    </v-row>
    <v-card class="pl-6 pr-6 pb-6">
      <!-- <v-card-title class="text-h6">Immigration Matter</v-card-title> -->
      <v-card-text>
        <v-row>
          <!-- ===================== Client ===================== -->
          <v-col cols="12" sm="4" md="4" style="padding:20px">
            <v-row style="color: #1d4ed8;background-color:#EFF6FF;border-radius:10px;">
              <v-col cols="12" sm="12" md="12">
                <h3>Client | ข้อมูลลูกค้า</h3>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3><span class="red--text">* </span>File Type</h3>
                <v-autocomplete
                  v-model="principal.file_type"
                  :items="filetype_list"
                  item-text="name"
                  item-value="id"
                  outlined
                  @change="onSelectCustomerChange(principal.tm_type)"
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3><span class="red--text">* </span>Client Name</h3>
                <v-autocomplete
                  clearable
                  @click:clear="
                    $nextTick(() => {
                      principal.customer_name = 0;
                      principal.agent_address = '';
                    })
                  "
                  v-model="principal.customer_name"
                  :items="customer_name_list"
                  item-text="name"
                  item-value="id"
                  outlined
                  @change="onSelectAgentChange(principal.customer_name)"
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3><span class="red--text">* </span>Client Name / Principle</h3>
                <v-text-field
                  v-model="principal.client_name"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3><span class="red--text">* </span>Nationality</h3>
                <v-text-field
                  v-model="principal.nationality"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3><span class="red--text">* </span>Contact</h3>
                <v-text-field
                  v-model="principal.contact"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3><span class="red--text">* </span>Case Worker</h3>
                <v-autocomplete
                  clearable
                  @click:clear="
                    $nextTick(() => {
                      principal.worker = 0;
                      principal.agent_address = '';
                    })
                  "
                  v-model="principal.worker"
                  :items="worker_list"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>Company Name</h3>
                <v-text-field
                  v-model="principal.company_name"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>Client Type</h3>
                <v-autocomplete
                  clearable
                  @click:clear="
                    $nextTick(() => {
                      principal.customer_type = 0;
                      principal.agent_address = '';
                    })
                  "
                  v-model="principal.customer_type"
                  :items="customer_type_list"
                  item-text="customer_type_name"
                  item-value="customer_type_id"
                  outlined
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>

          <!-- ===================== Visa + LTR ===================== -->
          <v-col cols="12" sm="4" md="4">
            <div style="border:1px solid grey;border-radius:10px;padding:20px">
              <v-row style="color: #1d4ed8;background-color:#EFF6FF;border-radius:10px;">
                <v-col cols="12" sm="12" md="12">
                  <h3>Visa</h3>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Visa Type</h3>
                  <v-autocomplete
                    clearable
                    @click:clear="$nextTick(() => { principal.visa_type = 0; })"
                    v-model="principal.visa_type"
                    :items="visa_type_list"
                    item-text="title"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Visa issue date</h3>
                  <v-menu
                    v-model="menuvisaissuedate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        @click:clear="$nextTick(() => { principal.visa_issue_date = ''; })"
                        v-model="principal.visa_issue_date"
                        persistent-hint
                        hint="Format DD/MM/YYYY"
                        @keydown.enter="visa_issue_date = parseDate(principal.visa_issue_date)"
                        @blur="visa_issue_date = parseDate(principal.visa_issue_date)"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="visa_issue_date"
                      @input="menuvisaissuedate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Place of issue</h3>
                  <v-autocomplete
                    clearable
                    @click:clear="$nextTick(() => { principal.place_of_issue = ''; })"
                    v-model="principal.place_of_issue"
                    :items="place_of_issue_list"
                    item-text="title"
                    item-value="title"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Visa expire date</h3>
                  <v-menu
                    v-model="menuvisaexpiredate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        @click:clear="$nextTick(() => { principal.visa_expire_date = ''; })"
                        v-model="principal.visa_expire_date"
                        persistent-hint
                        hint="Format DD/MM/YYYY"
                        @keydown.enter="visa_expire_date = parseDate(principal.visa_expire_date)"
                        @blur="visa_expire_date = parseDate(principal.visa_expire_date)"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="visa_expire_date"
                      @input="menuvisaexpiredate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>

            <!-- Toggle LTR Visa -->
            <v-checkbox
              v-model="principal.has_ltr"
              hide-details
              class="mt-2 mb-3 pa-1"
              style="border:1px solid grey;background-color:#F3F4F6;border-radius:4px;"
            >
              <template v-slot:label>
                <span style="font-weight:500;">
                  <v-icon small color="amber darken-2">mdi-star</v-icon>
                  LTR | มีวีซ่าประเภท LTR (พำนักระยะยาว)
                </span>
              </template>
            </v-checkbox>

            <div
              v-if="principal.has_ltr"
              style="border:1px solid grey;border-radius:10px;padding:20px"
            >
              <v-row style="color: #1d4ed8;background-color:#EFF6FF;border-radius:10px;">
                <v-col cols="12" sm="12" md="12">
                  <h3>
                    <v-icon small color="amber darken-2">mdi-star</v-icon>
                    LTR | วีซ่าพำนักระยะยาว
                  </h3>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>LTR Category | ประเภท LTR</h3>
                  <v-autocomplete
                    clearable
                    @click:clear="$nextTick(() => { principal.ltr_category = 0; })"
                    v-model="principal.ltr_category"
                    :items="ltr_category_list"
                    item-text="title"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>LTR Reference | เลขที่อ้างอิง/อนุมัติ LTR</h3>
                  <v-text-field
                    v-model="principal.ltr_reference"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>LTR Issue Date | วันที่อนุมัติ LTR</h3>
                  <v-menu
                    v-model="menultrissuedate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        @click:clear="$nextTick(() => { principal.ltr_issue_date = ''; })"
                        v-model="principal.ltr_issue_date"
                        persistent-hint
                        hint="Format DD/MM/YYYY"
                        @keydown.enter="ltr_issue_date = parseDate(principal.ltr_issue_date)"
                        @blur="ltr_issue_date = parseDate(principal.ltr_issue_date)"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="ltr_issue_date"
                      @input="menultrissuedate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>LTR Expiry Date | วันที่ LTR หมดอายุ</h3>
                  <v-menu
                    v-model="menultrexpiredate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        @click:clear="$nextTick(() => { principal.ltr_expire_date = ''; })"
                        v-model="principal.ltr_expire_date"
                        persistent-hint
                        hint="Format DD/MM/YYYY"
                        @keydown.enter="ltr_expire_date = parseDate(principal.ltr_expire_date)"
                        @blur="ltr_expire_date = parseDate(principal.ltr_expire_date)"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="ltr_expire_date"
                      @input="menultrexpiredate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <!-- ===================== Work Permit + PIT ===================== -->
          <v-col cols="12" sm="4" md="4">
            <v-checkbox
              v-model="principal.has_work_permit"
              hide-details
              class="mt-2 mb-3 pa-1"
              style="border:1px solid grey;background-color:#F3F4F6;border-radius:4px;"
            >
              <template v-slot:label>
                <span style="font-weight:500;">
                  <v-icon small color="amber darken-2">mdi-key-variant</v-icon>
                  Work Permit | ใบอนุญาตทำงาน
                </span>
              </template>
            </v-checkbox>

            <div v-if="principal.has_work_permit" style="border:1px solid grey;border-radius:10px;padding:20px">
              <v-row style="color:#16A34A;background-color:#F0FDF4;border-radius:10px;border-left:4px solid #22C55E;">
                <v-col cols="12" sm="12" md="12">
                  <h3>Work Permit</h3>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Alien ID | หมายเลขประจำตัวคนต่างด้าว (13 digits)</h3>
                  <v-text-field
                    v-model="principal.alien_id"
                    outlined
                    maxlength="13"
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Work Permit Number | เลขที่ใบอนุญาต</h3>
                  <v-text-field
                    v-model="principal.work_permit_number"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Work issue date</h3>
                  <v-menu
                    v-model="menuworkissuedate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        @click:clear="$nextTick(() => { principal.work_issue_date = ''; })"
                        v-model="principal.work_issue_date"
                        persistent-hint
                        hint="Format DD/MM/YYYY"
                        @keydown.enter="work_issue_date = parseDate(principal.work_issue_date)"
                        @blur="work_issue_date = parseDate(principal.work_issue_date)"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="work_issue_date"
                      @input="menuworkissuedate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Work Place of issue</h3>
                  <v-autocomplete
                    clearable
                    @click:clear="$nextTick(() => { principal.work_place_of_issue = ''; })"
                    v-model="principal.work_place_of_issue"
                    :items="work_place_of_issue_list"
                    item-text="title"
                    item-value="title"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Work expire date</h3>
                  <v-menu
                    v-model="menuworkexpiredate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        @click:clear="$nextTick(() => { principal.work_expire_date = ''; })"
                        v-model="principal.work_expire_date"
                        persistent-hint
                        hint="Format DD/MM/YYYY"
                        @keydown.enter="work_expire_date = parseDate(principal.work_expire_date)"
                        @blur="work_expire_date = parseDate(principal.work_expire_date)"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="work_expire_date"
                      @input="menuworkexpiredate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>

            <!-- Personal Income Tax Filing -->
            <v-checkbox
              v-model="principal.has_pit"
              hide-details
              class="mt-2 mb-3 pa-1"
              style="border:1px solid grey;background-color:#F3F4F6;border-radius:4px;"
            >
              <template v-slot:label>
                <span style="font-weight:500;">
                  <v-icon small color="deep-orange">mdi-file-document-outline</v-icon>
                  Personal Income Tax Filing | การยื่นภาษีเงินได้บุคคลธรรมดา
                </span>
              </template>
            </v-checkbox>

            <div
              v-if="principal.has_pit"
              style="border:2px solid grey;border-radius:10px;padding:20px"
            >
              <v-row style="color:#EA580C;background-color:#FFF7ED;border-radius:10px;border-left:4px solid #F97316;">
                <v-col cols="12" sm="12" md="12">
                  <h3 style="text-transform:uppercase;">
                    <v-icon small color="deep-orange">mdi-file-document-outline</v-icon>
                    Personal Income Tax Filing | ภาษีเงินได้บุคคลธรรมดา
                  </h3>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Tax Type | ภ.ง.ด. 90, 91, 95</h3>
                  <v-autocomplete
                    clearable
                    @click:clear="$nextTick(() => { principal.tax_type = 0; })"
                    v-model="principal.tax_type"
                    :items="tax_type_list"
                    item-text="title"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Tax ID | เลขประจำตัวผู้เสียภาษี</h3>
                  <v-text-field
                    v-model="principal.tax_id"
                    placeholder="0000000000000"
                    maxlength="13"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Type of Income | ประเภทเงินได้</h3>
                  <v-autocomplete
                    clearable
                    @click:clear="$nextTick(() => { principal.type_of_income = 0; })"
                    v-model="principal.type_of_income"
                    :items="type_of_income_list"
                    item-text="title"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Calendar Year (Tax) | ปีภาษี</h3>
                  <v-menu
                    v-model="menucalendaryeartax"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        @click:clear="$nextTick(() => { principal.calendar_year_tax = ''; })"
                        v-model="principal.calendar_year_tax"
                        persistent-hint
                        hint="Format DD/MM/YYYY"
                        @keydown.enter="calendar_year_tax = parseDate(principal.calendar_year_tax)"
                        @blur="calendar_year_tax = parseDate(principal.calendar_year_tax)"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="calendar_year_tax"
                      @input="menucalendaryeartax = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="1" md="1"> </v-col>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="1" md="1"></v-col>
        </v-row>

        <!-- ===================== Participants / Dependants ===================== -->
        <div class=" elevation-4 pa-6 mb-2" v-for="(item, i) in desserts" :key="i">
          <template>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn small outlined color="red" @click="removeParticipant(i)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4" sm="4">
                <h3>Relation to Principal Applicant | ความสัมพันธ์</h3>
                <v-autocomplete
                  v-model="item.type"
                  :items="participants_type_list"
                  item-text="name"
                  item-value="id"
                  ref="participantstype"
                  outlined
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <h3>Name | ชื่อ-นามสกุล</h3>
                <v-text-field
                  v-model="item.name"
                  ref="participantsname"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <h3>Nationality | สัญชาติ</h3>
                <v-text-field
                  v-model="item.nationality"
                  ref="participantsnationality"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4" sm="4">
                <h3>Visa Type</h3>
                <v-autocomplete
                  clearable
                  @click:clear="$nextTick(() => { item.visa_type = 0; })"
                  v-model="item.visa_type"
                  :items="visa_type_list"
                  item-text="title"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <h3>Visa expire Date</h3>
                <v-menu
                  v-model="item.menuVisa"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      @click:clear="
                        $nextTick(() => {
                          item.visa_expire = '';
                          item.visaPickerDate = null;
                        })
                      "
                      v-model="item.visa_expire"
                      persistent-hint
                      @keydown.enter="item.visaPickerDate = parseDate(item.visa_expire)"
                      @blur="item.visaPickerDate = parseDate(item.visa_expire)"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.visaPickerDate"
                    @input="
                      item.visa_expire = formatDate(item.visaPickerDate);
                      item.menuVisa = false;
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <h3>Work expire Date</h3>
                <v-menu
                  v-model="item.menuWork"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      @click:clear="
                        $nextTick(() => {
                          item.work_expire = '';
                          item.workPickerDate = null;
                        })
                      "
                      v-model="item.work_expire"
                      persistent-hint
                      @keydown.enter="item.workPickerDate = parseDate(item.work_expire)"
                      @blur="item.workPickerDate = parseDate(item.work_expire)"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.workPickerDate"
                    @input="
                      item.work_expire = formatDate(item.workPickerDate);
                      item.menuWork = false;
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </template>
        </div>

        <v-row class="mt-2">
          <v-col cols="12" md="12" sm="12">
            <v-btn block outlined color="blue" @click="save()">
              <v-icon color="blue">mdi-plus</v-icon>
              Add Applicant / Dependant
            </v-btn>
          </v-col>
        </v-row>

        <!-- ===================== Upload File ===================== -->
        <v-row class="mt-7">
          <v-col cols="12" sm="5" md="5">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>
                  Upload File
                  <span class="red--text">(Support .pdf files only) </span>
                </h3>
                <input
                  type="file"
                  accept="application/pdf,application/vnd.ms-excel"
                  multiple="multiple"
                  @change="previewMultiImage"
                  class="inputsize"
                  ref="filefile"
                  style="display: none"
                />
                <v-btn
                  :style="{ backgroundColor: '#254E58', color: 'white' }"
                  class="widthbtnimagefile"
                  @click="$refs.filefile.click()"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>Upload file
                </v-btn>
                <span v-if="filename.length > 0"> </span>
                <br />
                <span v-for="(item, index) in filename" :key="index">
                  <a @click="popuppreviewfile(index)">{{ item }}</a>
                  <v-btn
                    :disabled="sostatus"
                    :style="{ backgroundColor: '#FFEBEE', color: '#F44336' }"
                    small
                    icon
                    @click="popupdeletefile(index)"
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                  <br />
                </span>
              </v-col>
            </v-row>
            <br />
          </v-col>

          <v-col cols="12" sm="2" md="2" align="right"> </v-col>
          <v-col cols="12" sm="1" md="1"> </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col cols="12" sm="6" md="6">
            <v-row class="mt-n10">
              <v-col cols="12" sm="5" md="5"></v-col>
              <v-col cols="12" sm="1" md="1"></v-col>
              <v-col cols="12" sm="5" md="5"></v-col>
            </v-row>
            <v-col cols="12" sm="1" md="1"></v-col>
          </v-col>
        </v-row>

        <!-- ===================== Remark + Status ===================== -->
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <h3>Remark</h3>
            <v-textarea
              v-model="principal.remark"
              multi-line
              outlined
              dense
              hide-details
              rows="1"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <h3>status</h3>
            <v-autocomplete
              v-model="principal.status"
              :items="status_list"
              item-text="name"
              item-value="id"
              outlined
              @change="onSelectCustomerChange(principal.tm_type)"
              dense
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="mr-3 buttongold"
          @click="saveaddItem('createtransaction')"
        >
          Save and create Transaction
        </v-btn>
        <v-btn
          depressed
          width="100"
          class="mr-3 buttonblue"
          @click="saveaddItem('add')"
        >
          Save
        </v-btn>
        <v-btn depressed outlined width="100" @click="$router.back()">
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <!-- ===================== Dialogs ===================== -->
    <v-dialog v-model="dialogDeleteimage" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this image?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteimage">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirmimage">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >
        <div
          v-if="checkfileapreview"
          v-for="(item, index) in previewpopupfile2"
          :key="index"
        >
          <pdf :src="item" v-for="i in numPagespreview" :key="i" :id="i" :page="i">
            <template slot="loading">loading content here...</template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title
        >
        <v-img
          disabled
          :src="previewimage"
          class="grey lighten-2 mt-3 mb-5"
          aspect-ratio="1"
          contain
        ></v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewimage">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeletefile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeletefile">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirmfile">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEdit" max-width="600px">
      <v-card class="pa-8">
        <v-card-title class="text-h6">Edit Data</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-autocomplete
                  label="type"
                  v-model="dataeditItem.type"
                  :items="participants_type_list"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  type="text"
                  label="Name"
                  v-model="dataeditItem.name"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  type="text"
                  label="Nationality"
                  v-model="dataeditItem.nationality"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>Visa expire</h3>
                <v-menu
                  v-model="menuvisaexpireedittable"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      @click:clear="$nextTick(() => { dataeditItem.visa_expire = ''; })"
                      v-model="dataeditItem.visa_expire"
                      persistent-hint
                      hint="Format DD/MM/YYYY"
                      @keydown.enter="visa_expire_editintable = parseDate(dataeditItem.visa_expire)"
                      @blur="visa_expire_editintable = parseDate(dataeditItem.visa_expire)"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="visa_expire_editintable"
                    @input="menuvisaexpireedittable = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>Work expire</h3>
                <v-menu
                  v-model="menuworkexpireedittable"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      @click:clear="$nextTick(() => { dataeditItem.work_expire = ''; })"
                      v-model="dataeditItem.work_expire"
                      persistent-hint
                      hint="Format DD/MM/YYYY"
                      @keydown.enter="work_expire_editintable = parseDate(dataeditItem.work_expire)"
                      @blur="work_expire_editintable = parseDate(dataeditItem.work_expire)"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="work_expire_editintable"
                    @input="menuworkexpireedittable = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveeditItem()">Save</v-btn>
          <v-btn depressed outlined width="100" @click="closeeditItem()">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
  </v-container>
</template>

<script>
import api from "@/services/api";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
  fileImmigration,
} from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";
const moment = require("moment-timezone");
export default {
  name: "About",
  data(vm) {
    return {
      place_of_issue_list: [],
      work_place_of_issue_list: [],
      worker_list: [],
      customer_type_list: [
        { customer_type_id: "Company", customer_type_name: "Company" },
        { customer_type_id: "Agency", customer_type_name: "Agency" },
        { customer_type_id: "Personal", customer_type_name: "Personal" },
      ],
      customer_name_list: [],
      disableCalculateNewRenewalDate: false,
      country_list: [],
      date_of_public: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date_of_opposition: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date_of_filling_appeal: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date_of_filling_lawsuit: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date_of_renewal: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date_of_renewal_filed: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      next_deadline: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      visa_issue_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      visa_expire_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      work_issue_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      work_expire_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      participant_visa_issue_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      participant_workexpire_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menudate_of_issuing_certificate: false,
      menudate_of_closed: false,
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeletefile: false,
      dialogDeleteimage: false,
      fileindex: -1,
      indexdelete: -1,
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      tmstatus_list: [],
      contact_owner_list: [],
      contact_agent_list: [],
      contact_associate_list: [],
      filetype_list: [
        { id: "Global", name: "Global" },
        { id: "Local", name: "Local" },
        { id: "Personal", name: "Personal" },
      ],
      status_list: [
        { id: "Active", name: "Active" },
        { id: "Close", name: "Close" },
      ],
      participants_type_list: [
        { id: "Family", name: "Family/Dependant" },
        { id: "Spouse", name: "Spouse" },
        { id: "Children", name: "Children" },
        { id: "Parent", name: "Parent" },
      ],
      filename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      principal: {
        file_type: "",
        file_number: "",
        company_name: "",
        client_name: "",
        nationality: "",
        customer_type: "",
        contact: "",
        customer_name: 0,
        worker: 0,
        visa_type: 0,
        visa_issue_date: "",
        place_of_issue: "",
        visa_expire_date: "",
        alien_id: "",
        work_permit_number: "",
        work_issue_date: "",
        work_place_of_issue: "",
        work_expire_date: "",
        file: "",
        status: "Active",
        remark: "",
        company_id: localStorage.getItem(server.COMPANYID),
        user_create: localStorage.getItem(server.USER_ID),
        user_update: localStorage.getItem(server.USER_ID),
        has_ltr: false,
        ltr_category: 0,
        ltr_reference: "",
        ltr_issue_date: "",
        ltr_expire_date: "",
        has_work_permit: false,
        has_pit: false,
        tax_type: 0,
        tax_id: "",
        type_of_income: 0,
        calendar_year_tax: "",
      },
      menuaddappdate: false,
      menupublication: false,
      menuopposition: false,
      menufilling_appeal: false,
      menufilling_lawsuit: false,
      menurenewal: false,
      menurenewal_filed: false,
      menuaffidavits: false,
      menufiling_affidavits: false,
      menuvisaissuedate: false,
      menuworkissuedate: false,
      menuvisaexpiredate: false,
      menuworkexpiredate: false,
      participantsmenuvisaexpiredate: false,
      participantsmenuworkexpiredate: false,
      menuvisaexpireedittable: false,
      menuworkexpireedittable: false,
      menuadd: false,
      fullPage: true,
      datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ltr_category_list: [],
      menultrissuedate: false,
      menultrexpiredate: false,
      ltr_issue_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ltr_expire_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      tax_type_list: [],
      type_of_income_list: [],
      menucalendaryeartax: false,
      calendar_year_tax: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      search: "",
      mDataArray: [],
      desserts: [],
      headers: [
        { text: "* Type", value: "type", class: "bg-colorth texttablehcenter ", width: "17%", align: "start", divider: true, sortable: false },
        { text: "* Name", value: "name", class: "bg-colorth texttablehcenter", width: "25%", align: "start", divider: true, sortable: false },
        { text: "* Nationality", value: "nationality", class: "bg-colorth texttablehcenter ", width: "17%", divider: true, align: "end", sortable: false },
        { text: "* Visaexpire", value: "visa_expire", class: "bg-colorth texttablehcenter", width: "17%", divider: true, align: "end", sortable: false },
        { text: "Workexpire", value: "work_expire", class: "bg-colorth texttablehcenter", width: "17%", divider: true, align: "end", sortable: false },
        { value: "actions", class: "bg-colorth texttablehcenter", width: "8%", divider: true, sortable: false },
      ],
      defaultparticipants: {
        type: "",
        name: "",
        nationality: "",
        visa_expire: "",
        work_expire: "",
        user_create: localStorage.getItem(server.USER_ID),
        user_update: localStorage.getItem(server.USER_ID),
        visa_type: 0,
      },
      participants: {
        type: "",
        name: "",
        nationality: "",
        visa_expire: "",
        work_expire: "",
        user_create: localStorage.getItem(server.USER_ID),
        user_update: localStorage.getItem(server.USER_ID),
        menuVisa: false,
        visaPickerDate: null,
        menuWork: false,
        workPickerDate: null,
        visa_type: 0,
      },
      editedIndex: -1,
      dataeditItem: {
        type: "",
        name: "",
        nationality: "",
        visa_expire: "",
        work_expire: "",
        user_create: localStorage.getItem(server.USER_ID),
        user_update: localStorage.getItem(server.USER_ID),
      },
      dialogEdit: false,
      work_expire_editintable: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      visa_expire_editintable: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      visa_type_list: [],
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    pdf: pdfvuer,
  },
  async mounted() {
    await this.loadCustomer();
    await this.loadplace_of_issue_list();
    await this.loadwork_place_of_issue_list();
    await this.loadWorker();
    await this.loadvisa_types();
    await this.loadltr_category();
    await this.loadtax_type();
    await this.loadtype_of_income();
    // ----- โหลดข้อมูลเดิม (เหมือนหน้า Edit เดิม) -----
    await this.loaddataEdit();
    await this.loaddataEditintable();
    this.$hideLoader();
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        document.getElementById(p).scrollIntoView();
      }
    },
  },
  watch: {
    date_of_regis(val) {
      this.principal.date_of_regis = this.formatDate(this.date_of_regis);
    },
    date_of_application(val) {
      this.principal.date_of_application = this.formatDate(this.date_of_application);
    },
    date_of_public(val) {
      this.principal.date_of_public = this.formatDate(this.date_of_public);
    },
    date_of_opposition(val) {
      this.principal.date_of_opposition = this.formatDate(this.date_of_opposition);
    },
    date_of_filling_appeal(val) {
      this.principal.date_of_filling_appeal = this.formatDate(this.date_of_filling_appeal);
    },
    date_of_filling_lawsuit(val) {
      this.principal.date_of_filling_lawsuit = this.formatDate(this.date_of_filling_lawsuit);
    },
    date_of_renewal(val) {
      this.principal.date_of_renewal = this.formatDate(this.date_of_renewal);
    },
    date_of_renewal_filed(val) {
      this.principal.date_of_renewal_filed = this.formatDate(this.date_of_renewal_filed);
    },
    next_deadline(val) {
      this.principal.next_deadline = this.formatDate(this.next_deadline);
    },
    visa_issue_date(val) {
      this.principal.visa_issue_date = this.formatDate(this.visa_issue_date);
    },
    visa_expire_date(val) {
      this.principal.visa_expire_date = this.formatDate(this.visa_expire_date);
    },
    work_issue_date(val) {
      this.principal.work_issue_date = this.formatDate(this.work_issue_date);
    },
    work_expire_date(val) {
      this.principal.work_expire_date = this.formatDate(this.work_expire_date);
    },
    date_of_closed(val) {
      this.principal.date_of_closed = this.formatDate(this.date_of_closed);
    },
    date_of_issuing_certificate(val) {
      this.principal.date_of_issuing_certificate = this.formatDate(this.date_of_issuing_certificate);
    },
    participant_visa_issue_date(val) {
      this.participants.visa_expire = this.formatDate(this.participant_visa_issue_date);
    },
    participant_workexpire_date(val) {
      this.participants.work_expire = this.formatDate(this.participant_workexpire_date);
    },
    work_expire_editintable(val) {
      this.dataeditItem.work_expire = this.formatDate(this.work_expire_editintable);
    },
    visa_expire_editintable(val) {
      this.dataeditItem.visa_expire = this.formatDate(this.visa_expire_editintable);
    },
    ltr_issue_date(val) {
      this.principal.ltr_issue_date = this.formatDate(this.ltr_issue_date);
    },
    ltr_expire_date(val) {
      this.principal.ltr_expire_date = this.formatDate(this.ltr_expire_date);
    },
    calendar_year_tax(val) {
      this.principal.calendar_year_tax = this.formatDate(this.calendar_year_tax);
    },
  },
  methods: {
    removeParticipant(i) {
      this.desserts.splice(i, 1);
    },
    async openeditItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dataeditItem.type = item.type;
      this.dataeditItem.name = item.name;
      this.dataeditItem.nationality = item.nationality;
      this.dataeditItem.visa_expire = item.visa_expire;
      this.dataeditItem.work_expire = item.work_expire;
      this.dialogEdit = true;
    },
    async closeeditItem() {
      this.editedIndex = -1;
      this.dialogEdit = false;
    },
    async saveeditItem() {
      this.desserts[this.editedIndex].type = this.dataeditItem.type;
      this.desserts[this.editedIndex].name = this.dataeditItem.name;
      this.desserts[this.editedIndex].nationality = this.dataeditItem.nationality;
      this.desserts[this.editedIndex].visa_expire = this.dataeditItem.visa_expire;
      this.desserts[this.editedIndex].work_expire = this.dataeditItem.work_expire;
      this.dialogEdit = false;
    },
    // แปลงวันที่ที่โหลดมา (DD/MM/YYYY หรือ YYYY-MM-DD[Txx]) -> YYYY-MM-DD สำหรับ date-picker
    toPicker(d) {
      if (!d) return null;
      if (typeof d === "string" && d.includes("/")) {
        const [day, month, year] = d.split("/");
        if (!day || !month || !year) return null;
        return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      }
      return String(d).substr(0, 10);
    },
    async loadplace_of_issue_list() {
      const result = await api.getImMasterPlaceofissueByCompany_Dep({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      });
      this.place_of_issue_list = result.data;
    },
    async loadwork_place_of_issue_list() {
      const result = await api.getImMasterWorkPlaceofissueByCompany_Dep({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      });
      this.work_place_of_issue_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: { company_id: localStorage.getItem(server.COMPANYID) },
      });
      this.customer_name_list = result.data;
    },
    async loadWorker() {
      const result = await api.getAccountsByCompanyImmogration(localStorage.getItem(server.COMPANYID));
      this.worker_list = result.data;
    },
    async loadvisa_types() {
      const result = await api.getAll_visa_types(localStorage.getItem(server.COMPANYID));
      const list = [];
      if (result.data.length > 0) {
        let currentGroup = null;
        result.data.forEach((row) => {
          if (row.group_name !== currentGroup) {
            if (currentGroup !== null) list.push({ divider: true });
            list.push({ header: row.group_name });
            currentGroup = row.group_name;
          }
          list.push({ id: row.id, title: row.title, value: row.code });
        });
      }
      this.visa_type_list = list;
    },
    async loadltr_category() {
      const result = await api.getAll_ltr_category(localStorage.getItem(server.COMPANYID));
      this.ltr_category_list = result.data;
    },
    async loadtax_type() {
      const result = await api.getAll_tax_type(localStorage.getItem(server.COMPANYID));
      this.tax_type_list = result.data;
    },
    async loadtype_of_income() {
      const result = await api.getAll_type_of_income(localStorage.getItem(server.COMPANYID));
      this.type_of_income_list = result.data;
    },

    // ===================== โหลดข้อมูล principal เดิม =====================
    async loaddataEdit() {
      const result = await api.getdataByIdim_principal(this.$route.params.id);
      console.log(result);

      // รวมค่า default ของ field ใหม่ เผื่อ record เก่าไม่มี field เหล่านี้
      this.principal = Object.assign(
        {
          company_name: "",
          visa_type: 0,
          has_ltr: false,
          ltr_category: 0,
          ltr_reference: "",
          ltr_issue_date: "",
          ltr_expire_date: "",
          has_work_permit: false,
          alien_id: "",
          work_permit_number: "",
          has_pit: false,
          tax_type: 0,
          tax_id: "",
          type_of_income: 0,
          calendar_year_tax: "",
        },
        result.data[0]
      );

      this.principal.user_update = localStorage.getItem(server.USER_ID);

      // แปลงค่า checkbox ให้เป็น boolean (เผื่อ DB ส่งมาเป็น 1/0/"true")
      this.principal.has_ltr = this.toBool(this.principal.has_ltr);
      this.principal.has_work_permit = this.toBool(this.principal.has_work_permit);
      this.principal.has_pit = this.toBool(this.principal.has_pit);

      if (!this.principal.company_name) {
        this.principal.company_name = "";
      }

      // โหลดไฟล์เดิม
      if (this.principal.im_file) {
        this.filename = this.principal.im_file.split(",");
        this.filename.forEach((x, index) => {
          this.image_list.push(`${fileImmigration}/${this.$route.params.id}/${x}`);
          this.getpreview_list.push(`${fileImmigration}/${this.$route.params.id}/${x}`);
        });
      }
    },
    toBool(v) {
      return v === true || v === 1 || v === "1" || v === "true";
    },

    // ===================== โหลด participant เดิม =====================
    async loaddataEditintable() {
      const result = await api.getdataByIdim_participant(this.$route.params.id);
      console.log(result);
      // เติม field ที่ UI การ์ดใหม่ต้องใช้ (visa_type, picker, menu)
      this.desserts = (result.data || []).map((item) => ({
        ...item,
        visa_type: item.visa_type || 0,
        menuVisa: false,
        visaPickerDate: this.toPicker(item.visa_expire),
        menuWork: false,
        workPickerDate: this.toPicker(item.work_expire),
      }));
    },

    // ===================== เพิ่ม participant (UI การ์ดใหม่) =====================
    save() {
      if (this.desserts.length > 0) {
        const last = this.desserts[this.desserts.length - 1];

        if (last.type === 0 || last.type === "" || last.type === null) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "Failed", "Please enter Type", "text-h5 red--text text-center");
          return;
        }
        if (last.name === 0 || last.name === "" || last.name === null) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "Failed", "Please enter Name", "text-h5 red--text text-center");
          return;
        }
        if (last.nationality === 0 || last.nationality === "" || last.nationality === null) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "Failed", "Please enter Nationality", "text-h5 red--text text-center");
          return;
        }
        if (last.visa_expire === 0 || last.visa_expire === "" || last.visa_expire === null) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "Failed", "Please enter Visa Expire", "text-h5 red--text text-center");
          return;
        }
      }

      const newIndex = this.desserts.length + 1;
      this.desserts.push({
        ...this.participants, // copy ค่า ไม่ใช่ reference เดิม
        index: newIndex,
      });

      console.log(this.desserts);
      this.close();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.participants = Object.assign({}, this.defaultparticipants, {
          menuVisa: false,
          visaPickerDate: null,
          menuWork: false,
          workPickerDate: null,
          visa_type: 0,
        });
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    // ===================== บันทึก (UPDATE เหมือนหน้า Edit เดิม) =====================
    async saveaddItem(mode) {
      if (this.principal.file_type == 0 || this.principal.file_type == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", "Please enter File Type", "text-h5 red--text text-center");
        return;
      }
      if (this.principal.client_name == 0 || this.principal.client_name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", "Please enter Client Name", "text-h5 red--text text-center");
        return;
      }
      if (this.principal.nationality == 0 || this.principal.nationality == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", "Please enter Nationality", "text-h5 red--text text-center");
        return;
      }
      if (this.principal.contact == 0 || this.principal.contact == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", "Please enter Contact", "text-h5 red--text text-center");
        return;
      }
      if (this.principal.customer_name == 0 || this.principal.customer_name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", "Please enter Client Name", "text-h5 red--text text-center");
        return;
      }
      if (this.principal.worker == 0 || this.principal.worker == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", "Please enter Case Worker", "text-h5 red--text text-center");
        return;
      }


      const requiredFields = [
  { key: "type", label: "Type" },
  { key: "name", label: "Name" },
  { key: "nationality", label: "Nationality" },
  { key: "visa_expire", label: "Visa Expire" },
];

for (let i = 0; i < this.desserts.length; i++) {
  const row = this.desserts[i];

  for (const field of requiredFields) {
    const value = row[field.key];
    if (value === 0 || value === "" || value === null || value === undefined) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Failed",
        `Please enter ${field.label} (row ${i + 1})`,
        "text-h5 red--text text-center"
      );
      return;
    }
  }
}

      this.$showLoader();
      let formData = new FormData();
      formData.append(`file`, this.image);
      this.image_list.forEach((x, index) => {
        formData.append(`file`, x);
      });

      console.log(this.image_list);
      if (this.image_list.length > 0) {
        let getnamefilename = "";
        this.filename.forEach((x, index) => {
          if (index > 0) {
            getnamefilename += `,${x}`;
          } else {
            getnamefilename += `${x}`;
          }
        });
        formData.append(`im_file`, getnamefilename.replace(/\s/g, "_"));
      } else {
        formData.append(`im_file`, "");
      }

      formData.append("client_name", this.principal.client_name);
      formData.append("contact", this.principal.contact);
      formData.append("customer_name", this.principal.customer_name);
      formData.append("customer_type", this.principal.customer_type);
      formData.append("file_type", this.principal.file_type);
      formData.append("company_name", this.principal.company_name ? this.principal.company_name : "");
      formData.append("nationality", this.principal.nationality);
      formData.append("place_of_issue", this.principal.place_of_issue);
      formData.append("remark", this.principal.remark);
      formData.append("status", this.principal.status);
      formData.append("user_create", this.principal.user_create);
      formData.append("user_update", this.principal.user_update);
      formData.append("work_place_of_issue", this.principal.work_place_of_issue);
      formData.append("worker", this.principal.worker);
      formData.append("company_id", this.principal.company_id);

      // ----- field ใหม่ (เหมือนหน้า Add) -----
      formData.append("visa_type", this.principal.visa_type);
      formData.append("has_ltr", this.principal.has_ltr);
      formData.append("alien_id", this.principal.alien_id);
      formData.append("work_permit_number", this.principal.work_permit_number);
      formData.append("ltr_category", this.principal.ltr_category);
      formData.append("ltr_reference", this.principal.ltr_reference);
      formData.append("has_work_permit", this.principal.has_work_permit);
      formData.append("has_pit", this.principal.has_pit);
      formData.append("tax_type", this.principal.tax_type);
      formData.append("tax_id", this.principal.tax_id ? this.principal.tax_id : "");
      formData.append("type_of_income", this.principal.type_of_income);

      if (this.principal.visa_expire_date !== "" && this.principal.visa_expire_date !== null) {
        formData.append("visa_expire_date", this.changeformatDatetoinsert(this.principal.visa_expire_date));
      }
      if (this.principal.visa_issue_date !== "" && this.principal.visa_issue_date !== null) {
        formData.append("visa_issue_date", this.changeformatDatetoinsert(this.principal.visa_issue_date));
      }
      if (this.principal.work_expire_date !== "" && this.principal.work_expire_date !== null) {
        formData.append("work_expire_date", this.changeformatDatetoinsert(this.principal.work_expire_date));
      }
      if (this.principal.work_issue_date !== "" && this.principal.work_issue_date !== null) {
        formData.append("work_issue_date", this.changeformatDatetoinsert(this.principal.work_issue_date));
      }
      if (this.principal.ltr_issue_date && this.principal.ltr_issue_date !== "" && this.principal.ltr_issue_date !== null) {
        formData.append("ltr_issue_date", this.changeformatDatetoinsert(this.principal.ltr_issue_date));
      }
      if (this.principal.ltr_expire_date && this.principal.ltr_expire_date !== "" && this.principal.ltr_expire_date !== null) {
        formData.append("ltr_expire_date", this.changeformatDatetoinsert(this.principal.ltr_expire_date));
      }
      if (this.principal.calendar_year_tax && this.principal.calendar_year_tax !== "" && this.principal.calendar_year_tax !== null) {
        formData.append("calendar_year_tax", this.changeformatDatetoinsert(this.principal.calendar_year_tax));
      }

      const resultMasterTM = await api.updateim_principal(this.$route.params.id, formData);
      if (this.principal.status == "Close") {
        await api.updateByfile_noim_transaction(this.$route.params.id, { status: "Close" });
      }
      console.log(resultMasterTM);

      if (resultMasterTM.status == 200 || resultMasterTM.status == 201) {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Update",
          table_name: "IM_Principal",
          table_id: this.$route.params.id,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(localStorage.getItem(server.LOGIN_ID), dataEditLog);

        // ลบ participant เดิมทั้งหมด แล้วบันทึกใหม่ (เหมือนหน้า Edit เดิม)
        var res_participant_id_del = await api.getdataByIdim_participant(this.$route.params.id);
        const del_participant = await api.deleteim_participant(this.$route.params.id);
        console.log("del_participant.status", del_participant.status);

        if (del_participant.status == 200 || del_participant.status == 201) {
          for (const [index, item] of res_participant_id_del.data.entries()) {
            var dataDelParticipant = {
              user_id: localStorage.getItem(server.USER_ID),
              log_in_out_id: localStorage.getItem(server.LOGIN_ID),
              action: "Delete",
              table_name: "IM_Participant",
              table_id: item.id,
              date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            };
            await api.addTransectionLog(dataDelParticipant);

            var dataEditLog2 = {
              last_update: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            };
            await api.updateLogInOutLog(localStorage.getItem(server.LOGIN_ID), dataEditLog2);
          }
        }

        if (this.desserts.length > 0) {
          this.desserts.forEach(async (item, index) => {
            // สร้าง payload ใหม่ (ตัด field ที่ใช้เฉพาะ UI ออก)
            const payload = {
              type: item.type,
              name: item.name,
              nationality: item.nationality,
              visa_type: item.visa_type || 0,
              im_principal_id: this.$route.params.id,
              user_create: item.user_create || localStorage.getItem(server.USER_ID),
              user_update: localStorage.getItem(server.USER_ID),
              visa_expire: this.changeformatDatetoinsert(item.visa_expire),
              work_expire: this.changeformatDatetoinsert(item.work_expire),
            };

            var res_add_participant = await api.addim_participant(payload);

            var dataAddParticipant = {
              user_id: localStorage.getItem(server.USER_ID),
              log_in_out_id: localStorage.getItem(server.LOGIN_ID),
              action: "Create",
              table_name: "IM_Participant",
              table_id: res_add_participant.data.id,
              date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            };
            await api.addTransectionLog(dataAddParticipant);

            var dataEditLog3 = {
              last_update: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            };
            await api.updateLogInOutLog(localStorage.getItem(server.LOGIN_ID), dataEditLog3);

            console.log(`${index} = ${this.desserts.length - 1}`);

            if (index === this.desserts.length - 1) {
              this.$hideLoader();
              this.$store.state.global_push_dialog = true;
              if (mode == "add") {
                if (this.principal.status == "Close") {
                  this.setupAlertDialogPush(true, "save data", "ระบบจะทำการ Close Transaction ทั้งหมดของ Master นี้", "text-h5 green--text text-center", "/immigration-matter");
                } else {
                  this.setupAlertDialogPush(true, "save data", "save data success", "text-h5 green--text text-center", "/immigration-matter");
                }
              } else {
                if (this.principal.status == "Close") {
                  this.setupAlertDialogPush(true, "save data", "ระบบจะทำการ Close Transaction ทั้งหมดของ Master นี้", "text-h5 green--text text-center", `/immigration-transaction-add/${this.principal.file_number}`);
                } else {
                  this.setupAlertDialogPush(true, "save data", "save data success", "text-h5 green--text text-center", `/immigration-transaction-add/${this.principal.file_number}`);
                }
              }
              return;
            }
          });
        } else {
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          if (mode == "add") {
            if (this.principal.status == "Close") {
              this.setupAlertDialogPush(true, "save data", "ระบบจะทำการ Close Transaction ทั้งหมดของ Master นี้", "text-h5 green--text text-center", "/immigration-matter");
            } else {
              this.setupAlertDialogPush(true, "save data", "save data success", "text-h5 green--text text-center", "/immigration-matter");
            }
          } else {
            if (this.principal.status == "Close") {
              this.setupAlertDialogPush(true, "save data", "ระบบจะทำการ Close Transaction ทั้งหมดของ Master นี้", "text-h5 green--text text-center", `/immigration-transaction-add/${this.principal.file_number}`);
            } else {
              this.setupAlertDialogPush(true, "save data", "save data success", "text-h5 green--text text-center", `/immigration-transaction-add/${this.principal.file_number}`);
            }
          }
          return;
        }
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "save data", "can't save data", "text-h5 red--text text-center");
        return;
      }
    },

    async onSelectCountryChange(name) {},
    async onSelectAgentChange(id) {
      this.customer_name_list.filter((item) => {
        if (item.id == id) {
          this.principal.contact = item.contact_name;
          return;
        }
      });
    },
    async onSelectAssociateChange(id) {
      let setdata;
      setdata = this.contact_associate_list.filter((item) => {
        if (item.contact_id == id) {
          this.principal.associate_address = item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectCustomerChange() {},

    async popupdeletefile(index) {
      this.indexdelete = index;
      this.dialogDeletefile = true;
    },
    async closeDeletefile() {
      this.indexdelete = -1;
      this.dialogDeletefile = false;
    },
    deleteItemConfirmfile() {
      this.filename.splice(this.indexdelete, 1);
      this.preview_list.splice(this.indexdelete, 1);
      this.image_list.splice(this.indexdelete, 1);
      this.getpreview_list.splice(this.indexdelete, 1);
      this.closeDeletefile();
    },
    async closeDelete() {
      this.editedIndex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageadd = false;
      this.image = null;
      this.previewimage = "";
      this.imagename = "";
      this.dialogDeleteimage = false;
    },
    async popuppreviewfile(fileindex) {
      let pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>pdf file</title></head><body><iframe title='MY title'  width='100%' height='100%' src='" +
          this.getpreview_list[fileindex] +
          "'></iframe></body></html>"
      );
      return;
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      this.dialogpreviewimage = true;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimage = e.target.result;
          this.checkimageadd = true;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.imagename = this.image.name;
    },
    // previewMultiImage เวอร์ชันรองรับชื่อไฟล์ซ้ำ (เหมือนหน้า Edit เดิม)
    async previewMultiImage(event) {
      const input = event.target;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const files = Array.from(input.files);

      const promises = files.map((file) => {
        return new Promise((resolve) => {
          if (file.type === "application/pdf" || file.type.startsWith("image/")) {
            // ตรวจสอบชื่อซ้ำ
            let originalName = file.name || "file";
            let name = originalName;
            let counter = 1;

            while (this.filename.includes(name)) {
              const dotIndex = originalName.lastIndexOf(".");
              if (dotIndex !== -1) {
                const basename = originalName.substring(0, dotIndex);
                const extension = originalName.substring(dotIndex);
                name = `${basename}-${counter}${extension}`;
              } else {
                name = `${originalName}-${counter}`;
              }
              counter++;
            }

            const renamedFile = new File([file], name, { type: file.type });

            this.filename.push(name);
            this.image_list.push(renamedFile);

            const reader = new FileReader();
            reader.onload = (e) => {
              this.getpreview_list.push(e.target.result);
              this.preview_list.push(e.target.result);
              resolve();
            };
            reader.readAsDataURL(renamedFile);
          } else {
            resolve();
          }
        });
      });

      await Promise.all(promises);
      await this.getPdfforAdd(this.getpreview_list);

      this.preview_list2 = this.preview_list;
      this.checkfileeadd = true;

      console.log("✅ image_list", this.image_list);
      console.log("✅ filename", this.filename);
    },
    reset: function () {
      this.image = null;
      this.previewimage = null;
      this.image_list = [];
      this.preview_list = [];
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
      console.log(this.previewpopupfile);
    },
    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >= this.findPos(document.getElementById(i)) &&
                window.pageYOffset <= this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (window.pageYOffset >= this.findPos(document.getElementById(i))) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    handle_pdf_link: function (params) {
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },
    async CalculateNewRenewalDate() {
      let addyear = 10;
      let addday = 1;
      if (this.principal.date_of_renewal && this.principal.date_of_renewal != "") {
        this.date_of_renewal = new Date(
          new Date(this.date_of_renewal).setFullYear(
            new Date(this.date_of_renewal).getFullYear() + addyear,
            new Date(this.date_of_renewal).getMonth(),
            new Date(this.date_of_renewal).getDate() - addday
          ) - new Date().getTimezoneOffset() * 60000
        ).toISOString().substr(0, 10);
        this.principal.date_of_renewal = this.formatDate(this.date_of_renewal);
        this.disableCalculateNewRenewalDate = true;
      } else {
        if (!this.principal.date_of_application || this.principal.date_of_application == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "Failed", "Please enter Application Date Data", "text-h5 red--text text-center");
          return;
        }
        this.date_of_renewal = new Date(
          new Date(this.date_of_application).setFullYear(
            new Date(this.date_of_application).getFullYear() + addyear,
            new Date(this.date_of_application).getMonth(),
            new Date(this.date_of_application).getDate() - addday
          ) - new Date().getTimezoneOffset() * 60000
        ).toISOString().substr(0, 10);
        this.principal.date_of_renewal = this.formatDate(this.date_of_renewal);
        this.disableCalculateNewRenewalDate = true;
      }
    },
    async Selectchangedate_of_application() {},

    changeformatDatetoinsert(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.back-title {
  color: blue;
  transition: color 0.3s ease;
}
.back-title:hover {
  color: rgb(136, 136, 244);
}
.widthbtncal {
  width: 100%;
}
.widthbtnimagefile {
  width: 40%;
}
.widthsizesearch {
  width: 70%;
}
.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}
.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}
.btnuploadfile {
  border: 2px solid;
}
.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}
h3 {
  font-size: 1.17em;
}
h4 {
  font-size: 0.875rem;
}
.heightsize55formadvance {
  height: 55px;
}
</style>